/**
 * What a click on the per-property "Automatically Apply Maximum Risk Reduction"
 * toggle does (RAC-10476).
 *
 *   - shared-view collaborators: nothing (they cannot change screening)
 *   - account-wide auto-ESO is on (the landlord's own choice or the applicant-paid
 *     default): explain why the property is locked and where to change it — the
 *     server refuses a per-property change while it is on
 *   - otherwise: turn the property off, or open the enable flow
 *
 * Pure + framework-free on purpose so it is unit-testable in isolation.
 */

/**
 * @param {object} params
 * @param {boolean} params.isSharedViewOnly     True for shared-view collaborators.
 * @param {boolean} params.isAccountWideActive  Account-wide auto-ESO is on.
 * @param {boolean} params.isEnabled            The property's toggle currently reads on.
 * @returns {'none'|'explain'|'disable'|'enable'}
 */
export function autoEsoToggleClickAction({
    isSharedViewOnly = false,
    isAccountWideActive = false,
    isEnabled = false,
}) {
    if (isSharedViewOnly) {
        return 'none';
    }

    if (isAccountWideActive) {
        return 'explain';
    }

    return isEnabled ? 'disable' : 'enable';
}
